module.exports = __webpack_public_path__ + "img/banner4.e310f8ba.jpg";